export const faqs = [
  {
    question: "What is color correction?",
    answer:
      "Color correction is the process of adjusting the colors in your images to make them look natural, vibrant, and true to life. It includes fixing white balance, exposure, contrast, shadows, highlights, and color tones.",
  },
  {
    question: "Do you apply the same color style to all photos?",
    answer:
      "No. We maintain consistency across the set, but tailor the corrections based on the lighting, scene, and mood. We can also match your preferred editing style or reference images you provide.",
  },
  {
    question: "Can I request a specific editing style or preset?",
    answer:
      "Yes! If you have a particular style in mind or use your own Lightroom presets, we can apply them for consistency.",
  },
  {
    question: "How long does color correction take?",
    answer:
      "Turnaround time depends on the volume of photos. On average:\n- 100–300 photos: 1–2 days\n- 500–1000 photos: 2–3 days\nRush delivery is also available upon request.",
  },
  {
    question: "Do you use AI tools or manual editing?",
    answer:
      "We combine the power of AI tools for efficiency with manual adjustments for precision and creative control.",
  },
  {
    question: "Can you work with RAW files?",
    answer:
      "Absolutely. RAW files give us the most flexibility and highest quality results. We also accept JPEGs if RAW is not available.",
  },
  {
    question: "Is my photo quality affected during color correction?",
    answer:
      "No. We preserve your image quality and export at full resolution unless otherwise requested.",
  },
];
